import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class ScriptLoaderService {
    loadScript(path: string): Promise<void> {
        return new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = path;
            script.type = 'text/javascript';
            script.onload = () => resolve();
            script.onerror = () => reject(`Failed to load script: ${path}`);
            document.body.appendChild(script);
        });
    }
}
